// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leader-board-row-container {
  display: flex;
  flex: 1 1;
  max-height: 20px;
  background-color: rgb(240, 246, 255);
  justify-content: space-between;
  max-width: 85%;
  align-items: center;
}

.leader-board-table-row-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.leader-board-row-username-container {
  margin-left: 5px;
  display: flex;
}

.leader-board-row-score-container {
  margin-right: 5px;
}

.leader-board-row-score-container h4{
  margin: 0px;
}
.leader-board-row-username-container h4 {
  margin: 0px;
}

.leader-board-row-number-container {
  margin-right: 3px;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/HamburgerMenu/pages/Default/LeaderBoard/LeaderBoardRow/LeaderBoardRow.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".leader-board-row-container {\n  display: flex;\n  flex: 1;\n  max-height: 20px;\n  background-color: rgb(240, 246, 255);\n  justify-content: space-between;\n  max-width: 85%;\n  align-items: center;\n}\n\n.leader-board-table-row-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.leader-board-row-username-container {\n  margin-left: 5px;\n  display: flex;\n}\n\n.leader-board-row-score-container {\n  margin-right: 5px;\n}\n\n.leader-board-row-score-container h4{\n  margin: 0px;\n}\n.leader-board-row-username-container h4 {\n  margin: 0px;\n}\n\n.leader-board-row-number-container {\n  margin-right: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
